import type { Resource } from '../../';
export const login_title: Resource = {"default":"Login"};
